import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
}
export function CTAButton({
  href,
  children
}: CTAButtonProps) {
  return <a href={href} className="group inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-xl border-b-4 border-cta-dark bg-cta px-4 py-3 text-center font-display text-base font-extrabold uppercase leading-tight text-white shadow-lg shadow-cta/30 ring-4 ring-cta/15 transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-px sm:px-8 sm:py-4 sm:text-xl" data-id="element-28" data-mp="2kz7npo98lt6q">
      <span data-id="element-29" data-mp="33nuse5ni4gjs">{children}</span>
      <ChevronRightIcon className="hidden h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" strokeWidth={3} aria-hidden="true" data-id="element-30" data-mp="33r8vxh7wivst" />
    </a>;
}